<div class="quick-search">
    <aa-quick-search-word [storageKey]="'/admin/impersonate/popin/entity'"
                          (qsWordChanged)="onQsWordChanged($event)"></aa-quick-search-word>
</div>
<div class="multi-zone"
     *ngIf="!(isLoading | async) && isEmpty | async">
    <aa-lack-of-data [title]="'ADMIN.LIST.LACKOFDATA.TITLE' | translate"
                     [message]="">
    </aa-lack-of-data>
</div>
<div class="multi-zone"
     *ngIf="isLoading | async">
    <aa-spinning-loader-alt [loading]="isLoading | async"
                            [size]="2"
                            [color]="1">
    </aa-spinning-loader-alt>
</div>
<div class="multi-zone"
     *ngIf="!(isEmpty | async) && (isLoaded | async)">
    <cdk-virtual-scroll-viewport itemSize="30"
                                 class="virtual-scrollable-viewport aa-scrollable-y aa-scrollbar">
        <aa-impe-entity-item *cdkVirtualFor="let entity of entities; let idx = index; trackBy: entityIdTrackFn; first as isFirst; last as isLast"
                             [entity]="entity"
                             [firstItem]="isFirst"
                             [lastItem]="isLast"
                             [isSelected]="entity.id === (selectedId | async)">
        </aa-impe-entity-item>
    </cdk-virtual-scroll-viewport>
</div>